import React, { useState, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import { Typography } from "antd";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/free-regular-svg-icons';  
import { Link } from "react-router-dom";
import { notification } from "antd";
import { faCheckCircle, faExclamationCircle } from "@fortawesome/free-solid-svg-icons";
import SkeltonList from "../../../components/SkeltonEffect/list";
import Pagination from "@mui/material/Pagination";
import * as XLSX from 'xlsx';
import {createWinners} from "../../../controllers/V1/lottoWinnersControllers";
import OtpConfirmPopup from "../../../components/OtpConfirmPopup"
import {create as createLog} from "../../../controllers/activeLogsController";
const PreviewPopUp = ({ popUpOpen, togglePopUp, usersDetails=[], campaignData="", matchingCode="" }) => {
  const handleCancel = () => {
    togglePopUp([]);
    setCurrentRows([]);
    setTotalPages(0)

  }
  const [twoFactorVerify, setTwoFactorVerify] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const[ jsonData, setJsonData] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;
  const [start, setStart] = useState(0);
  const [currentRowsData, setCurrentRows] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [countData, setCountData] = useState({});
  const [searchValue, setSearchValue]=useState("");
  const [isOtpPopup, setOtpPopup] = useState(false);
  const toggleIsPopup = () => setOtpPopup(!isOtpPopup);

  const [gameType, setGameType] = useState("");
  const [winningNumber, setWinningNumber] = useState("");
  const [totalWinners, setTotalWinners] = useState(0);
  const [winningAmount, setWinningAmount] = useState(0);

  useEffect(()=>{
    setJsonData(usersDetails);
    const start = (currentPage - 1) * rowsPerPage;
    const currentRows = usersDetails.slice(start, start + rowsPerPage);
    const totalPages = Math.ceil(usersDetails?.length / rowsPerPage);
    setStart(start);
    setCurrentRows(currentRows);
    setTotalPages(totalPages);
    //Set Game Details
    setGameType(campaignData);
    setWinningNumber(matchingCode);
    setTotalWinners(usersDetails?.length);
    const totalWinningAmount = usersDetails.reduce((sum, item) => sum + item["WINNING AMOUNT"], 0);
    setWinningAmount(totalWinningAmount || 0);
    //End
  },[usersDetails?.length]);

  /*********************************************************
   *  This function is for handle page change
   *********************************************************/
  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage);

    const start = (newPage - 1) * rowsPerPage;
    const currentRows = jsonData.slice(start, start + rowsPerPage);

    setStart(start);
    setCurrentRows(currentRows);
  };

  const exportToExcel = async () => {
    try {
      if(jsonData && jsonData?.length > 0) {
        const workbook = XLSX.utils.book_new();
        const worksheet1 = XLSX.utils.json_to_sheet(jsonData);
  
        XLSX.utils.book_append_sheet(workbook, worksheet1, "Winner's List");
        XLSX.writeFile(workbook, `${new Date()}.xlsx`);
      } else{
        alert("No data found to export!");
      }
    } catch (error) {
      alert("Error generating Excel file: " + error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSearch = async () => {
    try {
      let filteredData = [...jsonData];
      // Perform search
      if (searchValue.trim() !== "") {
        const lowerQuery = searchValue.toLowerCase();
        filteredData = filteredData.filter(item =>
          Object.values(item).some(value =>
            String(value).toLowerCase().includes(lowerQuery)
          )
        );
      }
      setCurrentPage(1)
      const start = (1 - 1) * rowsPerPage;
      const currentRows = filteredData.slice(start, start + rowsPerPage);
      const totalPages = Math.ceil(filteredData?.length / rowsPerPage);
      setStart(start);
      setCurrentRows(currentRows);
      setTotalPages(totalPages);

    } catch (error) {
      console.log('error : ', error);
    }
  }
const adminUser = JSON.parse(sessionStorage.getItem("ADMIN-INFO"));
  const handleUpload = async () => {
    if(twoFactorVerify === false){
      toggleIsPopup();
    } else{
    setIsLoading(true);
    try {
      if(usersDetails && usersDetails.length > 0){
        const option = {
          param : usersDetails,
          game_name : gameType
        }
        const res = await createWinners(option);
        const logParam = {
          log : `${adminUser?.admin_email} create winner from analyser`,
          payload : `Total number of winners : ${usersDetails?.length || 0}`
        }
        createLog(logParam);
        if(res.status === true){
          notification.open({
            message: "Success",
            description: `User updated successfully..`,
            placement: "topRight",
            icon: (
              <FontAwesomeIcon
                icon={faCheckCircle}
                style={{ color: "green" }}
              />
            ),
            duration: 2,
          });
          handleCancel();
        } else{
          notification.open({
            message: "Error",
            description: `${res?.message}`,
            placement: "topRight",
            icon: (
              <FontAwesomeIcon
                icon={faExclamationCircle}
                style={{ color: "red" }}
              />
            ),
            duration: 2,
          });
        }
      }else{
        notification.open({
          message: "Error",
          description: `No winner found!`,
          placement: "topRight",
          icon: (
            <FontAwesomeIcon
              icon={faExclamationCircle}
              style={{ color: "red" }}
            />
          ),
          duration: 2,
        });
      }
    } catch (error) {
      setIsLoading(false);
      setError(error.message);
    } finally {
      setIsLoading(false);
    }
  }
  }

  return (
    <Dialog
      open={popUpOpen}
      onClose={handleCancel}
      fullWidth={true}
      maxWidth={"xl"}
      PaperProps={{
        className: "myDialogPopUp",
      }}
    >
      <div className="myDrawer">
        <div className="inventory_popup_title">
          <Typography variant="h5" component="div" gutterBottom className="inventory_popup_title_heading">
            {gameType || ""} Winner's List
          </Typography>
          <Link to={false} style={{ position: "absolute", right: 8, top: 8, color: "#dd5151" }} onClick={handleCancel}>
            <FontAwesomeIcon icon={faTimesCircle} />
          </Link>
        </div>
        

        <Typography variant="body1" component="div" className="my_delete_popup_paragraph">
          <div className="container-fluid">
            <div className="categories_open_popup_main_contnet">
              <form>
                <div className="form-group row">
                  <div className="col-lg-8 col-md-8 col-sm-8 col-xs-12">
                    <input type="text" name="name" id="name" onChange={(e)=>setSearchValue(e.target.value)} placeholder="Search ticket, seller's name, mobile number, coupon, ..." className="form-control categories_select_tg_enter_product" />
                  </div>
                  
                  <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12">
                    <button type="button" className="btn btn-danger" onClick={handleSearch}> Search </button>
                  </div>

                  <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12">
                    <button type="button" className="btn btn-danger" onClick={exportToExcel}> Export </button>
                  </div>

                  <div id="content-wrapper" className="d-flex flex-column">
                    <div className="card shadow mb-4">
                      <div className="card-body pt-0">
                        <div className="table-responsive">
                          <table
                            className="table table-bordered"
                            id="dataTable"
                            width="100%"
                            cellspacing="0"
                          >
                            <thead>
                              <tr>
                                <th>SL. NO.</th>
                                <th>TICKET ID</th>
                                <th>SELLER FIRST NAME</th>
                                <th>SELLER LAST NAME</th>
                                <th>SELLER MOBILE</th>
                                <th>COUPONS</th>
                                <th>STRAIGHT AMOUNT</th>
                                <th>RUMBLE AMOUNT</th>
                                <th>CHANCE AMOUNT</th>
                                <th>WINNER TYPE</th>
                                <th>WINNING AMOUNT</th>
                                <th>MATCHING NUMBER</th>
                              </tr>
                            </thead>
                            <tbody>
                              {currentRowsData?.length > 0 ? (
                                currentRowsData.map((items, index) => (
                                  <>
                                    <tr key={index} onClick={()=> console.log(items)} >
                                      <td> {start + index + 1} </td>
                                      <td>{items['TICKET ID']}</td>
                                      <td>{items['SELLER FIRST NAME']} </td>
                                      <td>{items['SELLER LAST NAME']}</td>
                                      <td>{items['SELLER MOBILE']}</td>
                                      <td>{items['COUPONS']}</td>
                                      <td>{items['STRAIGHT AMOUNT']}</td>
                                      <td>{items['RUMBLE AMOUNT']}</td>
                                      <td>{items['CHANCE AMOUNT']}</td>
                                      <td>{items['WINNER TYPE']}</td>
                                      <td>{items['WINNING AMOUNT']}</td>
                                      <td>{items['MATCHING NUMBER']}</td>
                                    </tr>
                                  </>
                                ))
                              ) : isLoading ? <SkeltonList row={5} col={8} /> : <tr> 
                                  <td colspan="8" className="img-center" >No data found !</td> 
                              </tr>}
                            </tbody>
                          </table>
                          {totalPages > 0 && (
                            <div className="table_pagination_sales_order">
                              <Pagination
                                count={parseInt(totalPages)}
                                onChange={handlePageChange}
                              />
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                    <h4>Game Type : {gameType || "N/A" }</h4>
                  </div>  

                  <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                    <h4>Winning numbers : {winningNumber || "N/A"}</h4>
                  </div>  

                  <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                    <h4>Total Winners : {totalWinners || ""}</h4>
                  </div>  

                  <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                    <h4>Total Winning Amount : {winningAmount || 0}</h4>
                  </div>  

                  <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div className="inventory_open_popup_action_btn">
                      <button type="button" className="btn btn-light categories_cancel_button" onClick={handleCancel}>Cancel</button>
                      <button type="button" className="btn btn-danger" onClick={handleUpload} disabled={isLoading}> {isLoading === true?`Uploading...`:`Upload Winners`}</button>
                    </div>
                  </div>

                </div>
              </form>
            </div>
          </div>
        </Typography>
        {error && <div style={{ color: 'red' }}>{error}</div>}
      </div>
      <OtpConfirmPopup popUpOpen={isOtpPopup} togglePopUp={toggleIsPopup} setTwoFactorVerify={setTwoFactorVerify} />
    </Dialog>
  );
};

export default PreviewPopUp;
